// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"1605":"9092d36c5bf95942","4719":"e15cc7e81171050f","4765":"b9e85bbc2b51d6a2","7991":"c264f34f9df35054"}[chunkId] + ".css";
};